module.exports = __webpack_public_path__ + "img/tv-retro.e2a0fc8a.svg";